import api from "@/api/api-v2-config";

export async function getCustomFieldListAxios(moduleName) {    
    return await api.get(`customfields/${moduleName}`);
}

export async function upsertCustomFieldsAxios(fields) {    
    return await api.post("customfields", fields);
}

export async function deleteCustomFieldsAxios(fieldId) {    
    return await api.delete(`customfields/${fieldId}`);
}